import GraphemeSplitter from 'grapheme-splitter';


export const splitAccurateEmoji = (str) => {
  if (typeof Intl !== 'undefined' && Intl.Segmenter) {
    const segmenter = new Intl.Segmenter('en', { granularity: 'grapheme' });
    return Array.from(segmenter.segment(str), s => s.segment);
  }

  const splitter = new GraphemeSplitter();
  return splitter.splitGraphemes(str);
};